export default "__VITE_ASSET__B2bAlSm1__"